import { cn } from '@vimond/theme/tailwind';
import { VariantProps, cva } from 'class-variance-authority';
import { ComponentProps } from 'react';

const fadeOutStyles = cva(
  ['object-cover', 'inset-0', 'absolute', 'h-full', 'w-full'],
  {
    variants: {
      variant: {
        top: ['bg-fade-top'],
        bottom: ['bg-fade-bottom'],
        left: ['bg-fade-left'],
        right: ['bg-fade-right'],
        'top-half': ['bg-fade-top-half'],
        'bottom-half': ['bg-fade-bottom-half'],
        'left-half': ['bg-fade-left-half'],
        'right-half': ['bg-fade-right-half'],
      },
    },
    defaultVariants: {
      variant: 'bottom',
    },
  },
);

type Props = ComponentProps<'div'> & VariantProps<typeof fadeOutStyles>;

export const FadeOutOverlay = ({ className, variant, ...props }: Props) => {
  return (
    <div className={cn(fadeOutStyles({ variant }), className)} {...props}></div>
  );
};
